import { SeasonEnum } from '@entities/Product';

export const LabelTyres = {
  Width: null,
  Height: null,
  Radius: null,
  Company: null,
  active_label: null,
};

export enum FilterSeason {
  SUMMER = 'summer',
  WINTER = 'winter',
  ALL = '',
}
export const mapSeason = {
  [FilterSeason.SUMMER]: SeasonEnum.Summer,
  [FilterSeason.WINTER]: SeasonEnum.Winter,
};

export enum TyresType {
  noMatter = '', // Неважно
  withoutSpikes = 0, // Без шипов
  studded = 1, // Шипованные
}

// для отображения в селекте
export enum TyresWidth {
  min = 175,
  max = 325,
}

export enum TyresHeight {
  min = 40,
  max = 90,
}
